import { TabPanel } from '@mui/lab';
import { Divider, Stack } from '@mui/material';

import type { AltriaOffersNearbyStatus } from '@ocx/feat-local-offers';
import { ExternalOfferFragment } from '@ocx/graphql';
import { Offer } from '@ocx/data-offers';
import { OfferCard } from '@ocx/ui-offers';

import { ExternalBannerCardController } from '../external-banner/external-banner-card.controller';
import { OfferCardController } from '../offer-card/offer-card.controller';

export type OffersCarouselPanelControllerProps = {
  id: string;
  offers: Offer[];
  banners: ExternalOfferFragment[];
  hasAltriaOffersNearby?: AltriaOffersNearbyStatus;
};

export const OffersCarouselPanelController = (props: OffersCarouselPanelControllerProps) => {
  const { id, offers, banners, hasAltriaOffersNearby } = props;

  return (
    <TabPanel value={id} sx={{ p: 0 }}>
      <Stack divider={<Divider variant="middle" />}>
        {banners.map((banner) => (
          <ExternalBannerCardController
            key={`${banner.bannerConfigurationUuid}_${banner.trackingId}`}
            banner={banner}
            hasAltriaOffersNearby={hasAltriaOffersNearby}
          />
        ))}
        {offers.map((offer) => (
          <OfferCardController key={offer.id} offer={offer}>
            {(props) => <OfferCard {...props} />}
          </OfferCardController>
        ))}
      </Stack>
    </TabPanel>
  );
};
